import { connect } from 'react-redux'

import { setSearchFilter } from '../tier-structure-actions'
import { filterViewData, createCopy } from '../tier-structure-utils'
import { generateGrouping } from '../../utils/utilities'

import ListViewNestedTreeContainer from '../../reusables/containers/list-view-nested-tree-container'
import Enums from '../../utils/enums'

const mapStateToProps = (state) => {
  if (!state[state.core.tabObject.activeApp]) {
    return {}
  }

  if (state.core.tabObject.activeApp !== Enums.APP_IDS.TIER_STRUCTURES) {
    return {}
  }

  const appId = state.core.tabObject.activeApp
  const data = state[appId].data
  const viewData = filterViewData(data, state[appId].searchFilter)
  const groupNameFilter = generateGrouping(viewData, 'groupName')
  const isActiveDescriptionFilter = generateGrouping(viewData, 'isActiveDescription')
  const nestedPropName = 'tierEntries'

  return {
    viewData,
    groupNameFilter,
    isActiveDescriptionFilter,
    nestedPropName
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onCreateCopy: (recordData, callback) => {
      createCopy(recordData, callback)
    },
    setSearchFilter: (value) => {
      dispatch(setSearchFilter(value))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListViewNestedTreeContainer)
